import React from 'react'
import ExperienceInfo from './ExperienceInfo/ExperienceInfo'
import AddExperience from './AddExperience/AddExperience'
import { Route, Routes } from 'react-router-dom'
import Experience from './Experience/Experience'
const ProfileExperience = (props) => {
    return (
        <div className="mt-6 mx-2 md:mx-6">
            <div>
                <Routes>
                    <Route path='/' element={<ExperienceInfo id={props.user.User?.id} />} />
                    <Route path='add' element={<AddExperience userID={props.user.User?.id} />} />
                    <Route path=':id' element={<Experience user={props.user} />} />
                </Routes>
            </div>
        </div>
    )
}

export default ProfileExperience

